/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- CREATE
// export const GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS = 'GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS'
// export const GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE = 'GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE'

// -- CREATE
export const CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS = 'CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS'
export const CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE = 'CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE'

// -- UPDATE
export const UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS = 'UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS'
export const UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE = 'UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE'

// -- DELETE
export const DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS = 'DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS'
export const DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE = 'DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE'

// -- FLOW_TASK_INTERACTION CACHE
export const CACHE_CREATE_FLOW_TASK_INTERACTION_RESOURCE = 'CACHE_CREATE_FLOW_TASK_INTERACTION_RESOURCE'
export const CACHE_UPDATE_FLOW_TASK_INTERACTION_RESOURCE = 'CACHE_UPDATE_FLOW_TASK_INTERACTION_RESOURCE'
export const CACHE_DELETE_FLOW_TASK_INTERACTION_RESOURCE = 'CACHE_DELETE_FLOW_TASK_INTERACTION_RESOURCE'

// ____________________________________________________________

/**
 * GET the list of tasks interaction resource broadcast two types of events:
 * - GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: in case of success.
 * - GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID.
 * @param {UUID} sid Scenario Id UUID.
 * @param {UUID} fid FlowGroup Id UUID.
 * @param {UUID} tid Flow Task UUID.
 * @returns {Promise<object>}
 */
// export const getFlowTaskInteractionResources = (pid, sid, fid, tid) => async (dispatch) => {
//   const path = getApiPath(apiPaths.FLOW_TASK_INTERACTION_RESOURCE_LIST, { pid, sid, fid, tid })
//   const api = new Api(path)
//   const result = await api.get()

//   Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTaskInteractionResources.getFlowTaskInteractionResources()', {
//     path,
//     result
//   })

//   if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
//     return dispatch({
//       type: GET_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
//       data: result.data.items || []
//     })
//   }
//   return dispatch({
//     type: GET_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
//     data: result.data
//   })
// }

/**
 * Create a new task interaction resource broadcast two types of events:
 * - CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: in case of success.
 * - CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID.
 * @param {UUID} sid Scenario Id UUID.
 * @param {UUID} fid FlowGroup Id UUID.
 * @param {UUID} tid Flow Task UUID.
 * @param {object} interaction Resource interaction to create
 * @returns {Promise<object>}
 */
export const createFlowTaskInteractionResource = (pid, sid, fid, tid, interaction) => async (dispatch) => {
  if (!interaction) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_TASK_INTERACTION_RESOURCE_CREATE, { pid, sid, fid, tid })
  const api = new Api(path)
  const result = await api.create(interaction)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTaskInteractionResources.createFlowTaskInteractionResource()', {
    path,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * Assign a Flow Task Interaction to the current flowTask, broadcast two types of events:
 * - UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: in case of success.
 * - UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID.
 * @param {UUID} sid Scenario Id UUID.
 * @param {UUID} fid FlowGroup Id UUID.
 * @param {UUID} tid Flow Task UUID.
 * @param {Array<object>} interaction Array of interaction object to add to the current Flow Task.
 * @returns {Promise<object>}
 */
export const updateFlowTaskInteractionResource = (pid, sid, fid, tid, interaction) => async (dispatch) => {
  if (!interaction) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_TASK_INTERACTION_RESOURCE_UPDATE, {
    pid,
    sid,
    fid,
    tid,
    rid: interaction.id
  })
  const api = new Api(path)
  const result = await api.update(interaction)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTaskInteractionResources.updateFlowTaskInteractionResource()', {
    path,
    interaction
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * Delete a flowGroup and broadcast two types of events:
 * - DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS: in case of success.
 * - DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE: in case of failure.
 *
 * @param {UUID} pid Project Id UUID.
 * @param {UUID} sid Scenario Id UUID.
 * @param {UUID} fid FlowGroup Id to delete.
 * @param {UUID} tid Flow Task UUID.
 * @param {UUID} rid Flow Task resource Id UUID.
 * @returns {Promise<object>}
 */
export const deleteFlowTaskInteractionResource = (pid, sid, fid, tid, rid) => async (dispatch) => {
  const path = getApiPath(apiPaths.FLOW_TASK_INTERACTION_RESOURCE_DELETE, { pid, sid, fid, tid, rid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowTaskInteractionResources.deleteFlowTaskInteractionResource()', {
    path,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_FLOW_TASK_INTERACTION_RESOURCE_SUCCESS,
      data: fid
    })
  }
  return dispatch({
    type: DELETE_FLOW_TASK_INTERACTION_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * Add the definition of a task instance interaction in the flowGroup's cache.
 *
 * @param {object} flowGroup the flow group of the task
 * @param {object} tid the identifier of the task instance to be updated
 * @param {object} interactions the array of interactions to be added
 * @returns {object}
 */
export const cacheCreateFlowTaskInteractionResource = (flowGroup, tid, interactions) => ({
  type: CACHE_CREATE_FLOW_TASK_INTERACTION_RESOURCE,
  data: {
    flowGroup,
    tid,
    interactions
  }
})

/**
 * Update the definition of a task instance interaction in the flowGroup's cache.
 *
 * @param {object} flowGroup the flow group of the task
 * @param {object} tid the identifier of the task instance to be updated
 * @param {object} interaction the resource interaction to be updated
 * @returns {object}
 */
export const cacheUpdateFlowTaskInteractionResource = (flowGroup, tid, interaction) => ({
  type: CACHE_UPDATE_FLOW_TASK_INTERACTION_RESOURCE,
  data: {
    flowGroup,
    tid,
    interaction
  }
})

/**
 * Remove the definition of a task instance interaction in the flowGroup's cache.
 *
 * @param {object} flowGroup the flow group of the task
 * @param {object} tid the identifier of the task instance to be updated
 * @param {object} resourceId the identifier of the resource interaction to be removed
 * @returns {object}
 */
export const cacheDeleteFlowTaskInteractionResource = (flowGroup, tid, resourceId) => ({
  type: CACHE_DELETE_FLOW_TASK_INTERACTION_RESOURCE,
  data: {
    flowGroup,
    tid,
    resourceId
  }
})
